import type { Socket } from 'socket.io-client';
import { io } from 'socket.io-client';

export const socketIo: Socket = io({
  host: window.location.host,
  path: '/api/socket.io',
});
